import { SelectField } from "$components/inputs";
import { Divider, MenuItem } from "@material-ui/core";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { useFacilityLocations } from "./use-facility-locations";

type Props = {
  value: string | null;
  onChange: (locationId: string | null) => void;
};

const allLocations = "ALL_LOCATIONS";

export function LocationSelectWithAllOption({ value, onChange }: Props) {
  const { formatMessage } = useIntl();
  const { data: locations, loading, error } = useFacilityLocations();

  const options = locations?.map(({ _id, name }) => ({
    value: _id,
    label: name,
  }));

  return (
    <SelectField
      name="location"
      id="inventory-overview-location-select"
      fullWidth
      hideHelper
      label={formatMessage({
        id: "inventory.overview.locationDropdown.placeholder",
        defaultMessage: "Location",
      })}
      options={options}
      selectProps={{
        value: value || allLocations, // selecting the default value doesn't work will with 'null'
        disabled: loading || locations?.length === 0,

        onChange: (e: React.ChangeEvent<{ value: string }>) => {
          const newValue = e.target.value;
          onChange(newValue === allLocations ? null : newValue);
        },
      }}
      error={error?.message}
      helperText={error?.message}
    >
      <Divider />
      <MenuItem
        data-testid="select-option-facility-wide"
        key="facility-wide"
        value={allLocations}
      >
        <FormattedMessage
          id="inventory.overview.locationSelect.allLocationsOption"
          defaultMessage="All Locations"
        />
      </MenuItem>
    </SelectField>
  );
}
